import { FacetSearchPayload, FacetSearchPayloadValues, PhotoFacetType } from '../types';

export function isFacetApplied(
    facetSearch: FacetSearchPayload,
    facetType: PhotoFacetType
): boolean {
    return facetSearch[facetType].length > 0;
}

export function getFirstAppliedFacet(
    facetSearch: FacetSearchPayload,
    facetType: PhotoFacetType
): FacetSearchPayloadValues[0] | null {
    const values = facetSearch[facetType];
    if (values) {
        return values[0];
    }
    return null;
}
